/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hold_Ctrl_Or_Command_To_Select_MultipleInputs */



/**
* | output |
* | --- |
* | "Hold Ctrl (Windows) or Command (Mac) to select multiple languages." |
*
* @param {Hold_Ctrl_Or_Command_To_Select_MultipleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const hold_ctrl_or_command_to_select_multiple = /** @type {((inputs?: Hold_Ctrl_Or_Command_To_Select_MultipleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hold_Ctrl_Or_Command_To_Select_MultipleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Maintenez Ctrl (Windows) ou Commande (Mac) pour sélectionner plusieurs langues.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Halten Sie Strg (Windows) bzw. Befehl (Mac) gedrückt, um mehrere Sprachen auszuwählen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tieni premuto Ctrl (Windows) o Comando (Mac) per selezionare più lingue.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для выбора нескольких языков удерживайте клавишу Ctrl (Windows) или Command (Mac).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mantenga presionada la tecla Ctrl (Windows) o Comando (Mac) para seleccionar varios idiomas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按住 Ctrl 键（Windows）或 Command 键（Mac）可选择多种语言。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("複数の言語を選択するには、Ctrl キー (Windows) または Command キー (Mac) を押し続けます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक से अधिक भाषाएँ चुनने के लिए Ctrl (Windows) या Command (Mac) को दबाकर रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mantenha pressionada a tecla Ctrl (Windows) ou Command (Mac) para selecionar vários idiomas.")
	return /** @type {LocalizedString} */ ("Hold Ctrl (Windows) or Command (Mac) to select multiple languages.")
});